import { render, staticRenderFns } from "./HowToJoinItem.vue?vue&type=template&id=5506492a&scoped=true"
import script from "./HowToJoinItem.vue?vue&type=script&lang=js"
export * from "./HowToJoinItem.vue?vue&type=script&lang=js"
import style0 from "./HowToJoinItem.vue?vue&type=style&index=0&id=5506492a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5506492a",
  null
  
)

export default component.exports